import VisuraToExcelComponent from "./visura-to-excel";

export const TIMER = 5000;
function VisuraToExcel() {
  return <VisuraToExcelComponent />;
}

export default VisuraToExcel;
